import React from "react";
import { Button, Icon } from "react-onsenui";
import { times, compact } from "lodash";
import {
  getColor, getReagents, getReagent,
} from "../../services/megamix";
import { isQueryEmpty, nullQuery } from "../../services/megamixUtils";
import QueryButton from "./QueryButton";
import { style as queryButtonStyle } from "./QueryButton";
import QueryEditorModal from "./QueryEditorModal";
import { encodeQueries, encodeQueriesToUrl } from "../../services/queriesEncoder";
import ShareUrlButton from "../ShareUrlButton";

const style = {
  container: {
    //position: "fixed",
    //bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    flexDirection: "column",
    marginBottom: "-15px"
  },
  queriesContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    flexDirection: "row",
    gap: "10px",
    marginTop: "15px"
  },
  resetQueriesButton: {
    ...queryButtonStyle.addQueryButton,
    marginRight: 4,
    // fontWeight: "bold",
    borderRadius: "5px",
    height: "40px",
    width: "40px",
    border: "1px solid lightgrey",
    marginTop: "-15px",
    marginRight: "10px",
  },
  shareQueriesButton: {
    ...queryButtonStyle.addQueryButton,
    marginRight: 0,
    // fontWeight: 'bold',
    borderRadius: "5px",
    height: "40px",
    width: "40px",
    border: "1px solid lightgrey",
    marginTop: "-15px"
  },
};

export default class SelectQueries extends React.Component {
  state = {
    // Start with first query open
    openedQueryIndex: 0,
    shareOpen: null,
    copyDisplay: false,
  };

  // Close modal with ESC key
  escFunction(event) {
    if (event.keyCode === 27) {
      this.closeQueryEditorModal();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction.bind(this), false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction.bind(this), false);
  }

  handleQueryChange(queryIndex, newQuery) {
    if (queryIndex == null) {
      console.log("No queryIndex!");
      return;
    }

    const { queries, onQueriesChange } = this.props;

    // Special case when removing single last query - instead removing it, clear the colors
    if (queries.length == 1 && newQuery == null || newQuery == []) {
      let query = queries[0];
      query.colorIds = [];
      onQueriesChange([query]);
      return;
    }

    let deletedQueryBeforeCurrentQuery = false;

    let newQueries = [...queries]; // clone array
    if (newQuery != null) {
      newQueries[queryIndex] = newQuery;
    } else {
      if (this.state.openedQueryIndex != null && queryIndex < this.state.openedQueryIndex) {
        deletedQueryBeforeCurrentQuery = true;
      }
      delete newQueries[queryIndex];
    }
    newQueries = compact(newQueries);
    onQueriesChange(newQueries);

    // Deleted currently open query
    if (newQuery == null && queryIndex == this.state.openedQueryIndex) {
      this.setState({ openedQueryIndex: null });
    }
    // Current query index has changed
    else if (deletedQueryBeforeCurrentQuery) {
      this.setState({ openedQueryIndex: this.state.openedQueryIndex - 1 });
    }
  }

  openQueryEditorModal(index) {
    const { queries } = this.props;
    const query = queries[index];
    if (isQueryEmpty(query)) {
      const usedReagentIds = (
        queries
        .filter(q => !isQueryEmpty(q))
        .map(q => q.reagentId)
      );
      const availableReagentIds = (
        getReagents()
        .map(r => r.id)
        .filter(rId => !usedReagentIds.includes(rId))
      );
      this.handleQueryChange(index, {
        reagentId: availableReagentIds[0],
        colorIds: []
      });
    }
    this.setState({ openedQueryIndex: index });
  }

  closeQueryEditorModal() {
    const query = this.props.queries[this.state.openedQueryIndex];
    if (isQueryEmpty(query)) {
      this.handleQueryChange(this.state.openedQueryIndex, null);
    }
    this.setState({ openedQueryIndex: null });
  }

  renderQueryEditorModal() {
    const isQueryModalOpen = this.state.openedQueryIndex != null;

    const { queries, currentSubstanceIds } = this.props;
    const usedReagentIds = (
      queries
      .filter(q => !isQueryEmpty(q))
      .map(q => q.reagentId)
    );
    const availableReagentIds = (
      getReagents()
      .map(r => r.id)
      .filter(rId => !usedReagentIds.includes(rId))
    );

    const query = queries[this.state.openedQueryIndex] || {};

    return (
      <div className="query-editor-wrapper" aria-hidden={isQueryModalOpen}>
        <div className="query-editor-container">
          <QueryEditorModal
            onClose={this.closeQueryEditorModal.bind(this)}
            queries={queries}
            query={query}
            availableReagentIds={availableReagentIds}
            currentSubstanceIds={currentSubstanceIds}
            onQueryChange={newQuery =>
              this.handleQueryChange(this.state.openedQueryIndex, newQuery)
            }
            onQueryDelete={() => this.handleQueryChange(this.state.openedQueryIndex, null)}
          />
        </div>
      </div>
    );
  }

  onAddButtonClicked() {
    const { queries } = this.props;
    if (this.state.openedQueryIndex == null || (
      this.props.queries[this.state.openedQueryIndex] != null &&
      this.props.queries[this.state.openedQueryIndex].colorIds.length > 0)
      ) {

        // If query is default query (single one with no colors), edit it instead of adding new one
        if (queries.length == 1 && queries[0].colorIds.length == 0) {
         this.openQueryEditorModal(0, "edit");
        } else {
         this.openQueryEditorModal(this.props.queries.length, "create");
        }
    }
  }

  onEditButtonClicked(index) {
    if (this.state.openedQueryIndex == index) {
      this.closeQueryEditorModal();
    } else {
      this.openQueryEditorModal(index, "add");
    }
  }

  onResetButtonClicked() {
    this.closeQueryEditorModal();
    this.props.onQueriesReset();
  }

  isQueriesDefault() {
    const { queries, onQueriesReset } = this.props;
    return queries.length == 1 && queries[0].colorIds.length == 0;
  }

  render() {
    const { queries, onQueriesReset } = this.props;

    return (
      <div
        style={style.container}
        className="fixed-to-bottom-tabbar"
      >
        <div style={style.queriesContainer} className="reaction-queries-container">
          {/* Edit query buttons */}
          {times(queries.length).map((index) => (
            <QueryButton
              key={index}
              queryIndex={index}
              query={queries[index]}
              queryEditMode={index == this.state.openedQueryIndex}
              onClick={() => this.onEditButtonClicked(index)}
              onDeleteClick={() => this.handleQueryChange(index, null)}
            />
          ))}

          {/* Add query button */}
          {!this.isQueriesDefault() &&
            <QueryButton
              noQueries={queries.length === 0}
              query={nullQuery}
              onClick={() => this.onAddButtonClicked()}
            />
          }

          {/* Delete all queries button */}
          {/* {queries.length > 0 && (
            <Button
              modifier="secondary"
              style={style.resetQueriesButton}
              onClick={() => this.onResetButtonClicked()}
            >
              <Icon
                icon="fa-trash"
                size={20}
              />
            </Button>
          )} */}
        </div>

        {this.renderQueryEditorModal()}
      </div>
    );
  }
}
